import React from 'react'
import PropTypes from 'prop-types'

export const CourseSectionFilter = ({ filter, handleText, checkedFilter }) => {
  let labelValue = `button-for-${filter}`
  return (
    <li className="list-unstyled">
      <input
        id={labelValue}
        name="courseSection"
        className="mr-2"
        value={filter}
        checked={filter === checkedFilter}
        onChange={handleText}
        type="radio"
      />
      <label htmlFor={labelValue}>
        {filter}
      </label>
    </li>
  )
}

CourseSectionFilter.propTypes = {
  filter: PropTypes.string,
  handleText: PropTypes.func,
  checkedFilter: PropTypes.string,
}
